// Angular
import { ChangeDetectorRef, Component, EventEmitter, OnInit, ViewChild, Output, Input } from '@angular/core'
import { MatPaginator } from '@angular/material'
import { ActivatedRoute, Router } from '@angular/router'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
// Services
import { PanierLine } from '../../../../../Interfaces/Panier'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { InstructionService } from '../../../../../services/WebService/instruction.service'

import { LayoutConfigService } from '../../../../../core/_base/layout'
import { AppService, ConsultationService, ParameterService, StateService, ListeService } from '../../../../../services'
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogService } from '../../../../../services'
import { PanierInstructionComponent } from '../../../layout/dialogs/panier-instruction-dialog/panier-instruction.component'
import { ChoiceCourrierComponent } from '../../../layout/dialogs/choice-courrier-dialog/choice-courrier.component'
import { LoadDialogComponent } from '../../../layout/dialogs/load-dialog/load.component'
import { VisiteActionsDialog } from '../../../content/actions/visite-actions-dialog/visite-actions-dialog.component'
import { of,Observable, Subject,  } from 'rxjs'

const KEY = 'DASHBOARD'

@Component({
    selector: 'atyl-dashboard-tab-encours',
    templateUrl: './dashboard-tab-encours.component.html',
    styleUrls: ['dashboard-tab-encours.component.scss'],
})
@Stringable({
    path: 'views/pages/dashboard/dashboard',
    key: KEY,
})
export class DashboardTabEnCoursComponent implements OnInit {
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator
    
    @StringableValues(KEY)
    strings: any
    
    inited = new EventEmitter<any>();

    @Input() parameters: any;
    	@Input() load: Observable<any>;
		
    //@Output() lengthInstru :number = 0;
    @Output() lengthInstru: EventEmitter<number> = new EventEmitter<number>();
    @Output() rowClicked: EventEmitter<any> = new EventEmitter<any>();
    
    loadingInstru: any = true;
    /*
    columnsNotification:any=[];
    dataNotification:any=[];
    PaginationNotification:number=10;
    currentPageNotification :number = 0;
    loadingNotification:boolean=false;
    sortNotification: any;
    */
    columnsInstruction: any = [];
    dataInstruction: any = [];
    PaginationInstruction: number = 10;
    currentPageInstruction: number = 0
    loadingInstruction: boolean = false;
    sortInstruction: any
    lengthInstruCount: number = 0;

    disabledPanier:boolean=true;
    element:PanierLine[]=[];

    user:any = null;
    demande: any;

	subrs:any[]=[];
	
	isExportCSV:boolean=false;
	isExportPDF:boolean=false;
		
    constructor(
        private layoutConfigService: LayoutConfigService,
        private parameterService: ParameterService,
        private stateService: StateService,
        private router: Router,
        private appService: AppService,
        private changeDetectorRef: ChangeDetectorRef,
        private activatedRoute: ActivatedRoute,
        private consultationService: ConsultationService,
        private instructionService:InstructionService,
        private snackbar: MatSnackBar,
        private dialogService: DialogService,
        private listeService: ListeService
    ) {
    }

    
    ngOnInit(): void {
        console.log('dashboard tab encours', this.strings)
        console.log("on init",this.currentPageInstruction)
        this.getDataPageInsctrution(this.currentPageInstruction,true,true);
        this.stateService.user.subscribe((user) => {
            this.user = user
        });
        this.stateService.demande.subscribe((demande) => {
            this.demande = demande;
        });
		
		this.subrs.push(
			this.load.subscribe((loading:any) => {
				console.log("DashboardTabEnCoursComponent",loading)
				 if (loading.load!=undefined &&loading.load)  {
			         if (loading.parameters!=undefined)
						this.parameters=loading.parameters;
			         
			         this.getDataPageInsctrution(this.currentPageInstruction,true);
				}	
		     
			})
		);
		
    }

    ngOnChanges(changes) {
      // this.getDataPageInsctrution(this.currentPageInstruction,true);
    }

    ngOnDestroy() {
		this.subrs.forEach( (sb: any) => {;
				     	sb.unsubscribe();
				 })
    }

    ngAfterViewInit() {
      // this.getDataPageInsctrution(this.currentPageInstruction,true);
    }

    getInitedEmitter() {
        return this.inited;
    }
    
    getDataPageInsctrution(page: number = 0, init: boolean = false, nodata: boolean = false) {
        let _options = {
            page: page,
			pageSize:this.PaginationInstruction,
            sorts: [this.sortInstruction],
            filters: {
                zone: {value:this.parameters.zoneInput},
                tiers: {value:this.parameters.tiersInput},
                metier : {value:this.parameters.metierInput},
                enCours : {value:this.parameters.enCoursInput},
                procedure : {value:this.parameters.procedureInput},
                action : {value:this.parameters.actionInput},
                statut : {value:this.parameters.statutInput},
                commune : {value:this.parameters.communeInput},
				reference : {value:this.parameters.referenceInput},
				alltiers: {value:this.parameters.allTiersInput},
				grouptiers: {value:this.parameters.allGroupTiersInput},
				groupListtiers: {value:this.parameters.allGroupTiersListInput},
				groupeTiers: {value:this.parameters.groupTiersInput},
            }
        }
		console.log("DashboardTabEnCoursComponent load",_options,this.parameters,nodata);
        this.loadingInstruction = true;
		this.subrs.push(
        this.listeService.get('INSTRUCTION', _options, nodata)
	            .subscribe((list:JSONRpcResponse) => {
	                this.element = [];
	                //  this.loadingNotif = false;
	                this.columnsInstruction = list.result.columns;
	                this.dataInstruction = list.result.datas.datas;
	                if (list.result.datas.meta) {
	                    this.lengthInstru.emit( list.result.datas.meta.total);
	                    this.lengthInstruCount=list.result.datas.meta.total;
	                    this.PaginationInstruction = list.result.datas.meta.perpage;
	                    this.currentPageInstruction = list.result.datas.meta.page;
	                }
	                this.loadingInstru = false;
	                this.loadingInstruction = false;
	
					if (list.result.options!=undefined 
										&& list.result.options.parameters!=undefined 
										&& list.result.options.parameters.export!=undefined 
										&& Array.isArray(list.result.options.parameters.export) ) {
						this.isExportCSV=(list.result.options.parameters.export.includes("CSV") || list.result.options.parameters.export.includes("XLSX"));
						this.isExportPDF=(list.result.options.parameters.export.includes("PDF"));
						console.log('load data export', list.result.options.parameters.export, this.isExportPDF,this.isExportCSV)						
					}
					
					
	                this.inited.emit(list.result);
	                this.changeDetectorRef.detectChanges();
	                console.log("getDataPageInsctrution columnsInstruction",this.columnsInstruction,"\nlengthInstru:",
	                this.lengthInstru,"\nPaginationInstruction:",this.PaginationInstruction,"\ncurrentPageInstruction:",this.currentPageInstruction
	                ,"\nlengthInstruCount:",this.lengthInstruCount,"\ndataInstruction:",this.dataInstruction,"\nlist",list);
	            })
			);
    }
    onPagedInstruction(table: any) {
		this.PaginationInstruction=table.pageSize;
        this.getDataPageInsctrution(table.currentPage);
    }
    onRowClickedInstruction(row: any) {

        let clickRow={
            row: row,
            origin: 'instruction'
            
        }
        this.rowClicked.emit(clickRow);
/*
        if (row['demande.dossier.tiers.type.code'] === 'ASSMAT')
            this.router.navigate(['/home/assistmat/' + row['demande.dossier.id']])
        else if (row['demande.dossier.tiers.type.code'] === 'EAJE')
            this.router.navigate(['/home/eaje/' + row['demande.dossier.id']])
        else if (row['demande.dossier.tiers.type.code'] === 'MAM')
            this.router.navigate(['/home/mam/' + row['demande.dossier.id']])
        else if (row['demande.dossier.tiers.type.code'] === 'GESTIONNAIRE')
            this.router.navigate(['/home/gestionnaire/' + row['demande.dossier.id']])
        else if (row['demande.dossier.tiers.type.code'] === 'STRUCTURE_GESTION')
            this.router.navigate(['/home/structgestion/' + row['demande.dossier.id']])
        else if (row['demande.dossier.tiers.type.code'] === 'RAM')
            this.router.navigate(['/home/ram/' + row['demande.dossier.id']])
            */

    }

    onHeaderClickedInstruction(sort: any) {
        this.sortInstruction = {
            id: sort.active,
            direction: sort.direction.toUpperCase()
        }
        this.getDataPageInsctrution(this.currentPageInstruction)
    }
    
    selectChanged(event) {
        this.disabledPanier=true;
        this.element = []
		let _options ={
			demande: false
		}
		let oo:any[]=Object.keys(event);
		let cpt:number=0;
        
		Object.keys(event).forEach(key => {			
            this.instructionService.get(key,_options).subscribe((res: JSONRpcResponse) => {
                cpt++;
                if (res.result && res.result.type 
                    && !this.element.find(elem=>elem.instruction.ID == res.result.ID)) {
					let line:PanierLine=new PanierLine();                        
                    if (res.result.demande!=undefined && res.result.demande.dossier!=undefined)
                        line.dossier=res.result.demande.dossier.tiers;
                    if (res.result.type!=undefined && res.result.demande){
                        line.instruction=res.result;
                        this.element.push(line);
                        if (cpt==oo.length)
                            this.disabledPanier=false;
                        this.changeDetectorRef.detectChanges();
				    }
                }
			})
		});
    }

    multiAction(actionType: string){
        var donnees = [];
        this.element.forEach(elem => {
            let line={
                dossier: elem["dossier"],
                instruction:elem["instruction"]
            }
            donnees.push(line);
        });
        const title = actionType == "reattribution"? "Réattribution procédures"
        : "Changement d'étape procédures";

        this.dialogService.open(PanierInstructionComponent, {
            data: {
                donnees: donnees,
                user: this.user,
                origine: actionType,
                title: title
            }
        }, (res: any) => {
            if (res){
                if(actionType === "reattribution"){
                    this.instructionReattributionMulti(res);
                }
                else if(actionType === "etape"){
                    this.instructionEtapeMulti(res);
                }
            }
            else{
                console.log("Boite dialogue fermée avec erreur");
            }
        })
    }

    instructionReattributionMulti(res){
        var options = res;
        options.instructeur = res.instructeur? res.instructeur.ID : null;
        options.auto = res.auto,
        options.id = [];
    
        for(let i=0;i<this.element.length;i++){
            if(this.element[i].instruction)
                options.id.push(this.element[i].instruction.ID);
        }
        this.instructionService.setMultipleID(options).subscribe((res) => {
            if (res){
                const message = res.result.length+' procédure(s) modifiée(s).'
                let snackBarRef = this.snackbar.open(message,'', {
                    duration: 1500
                });
                if(res.result.length>0){
                    this.getDataPageInsctrution(this.currentPageInstruction,true);
                }
            }
        });
    }

    instructionEtapeMulti(res){
		let instruction = [];
		let options = [];
        if (res.etape && !res.cancel) {
            if(res.etape.length > 0
            && res.tabID.length > 0)
            {
                for(let i=0;i<this.element.length;i++){
                    for(let k=0;k<res.tabID.length;k++){
                        if(this.element[i].instruction.ID == res.tabID[k]){
                            instruction.push(this.element[i].instruction)
                        }
                    }
                }
                for(let i=0;i<instruction.length;i++){
                    let params = {
                        ID:instruction[i].ID,
                        type: instruction[i].type.key,
                        transition: res.etape[i].key,
                        transition_demande_type: res.transition_demande_type ? res.transition_demande_type : null,
                        titre: res.titre ? res.titre:null,
                        comment:null
                    };
                    if(params.comment !== undefined
                    && params.comment != "undefined"
                    && params.comment !== null)
                        params.comment = res.comment ? res.comment : null;

                    options.push(params);
                }

                this.instructionService.setTransitionGroupe(options).subscribe((res: JSONRpcResponse) => {
                    if(res){
                        for(let i=0;i<this.element.length;i++){
                            for(let k=0;k<res.result.length;k++){
                                if(this.element[i].instruction.ID == res.result[k].ID){
                                    this.element[i].instruction = res.result[k];
                                    console.log("La procédure ID =",this.element[i].instruction.ID,"est passée à l'étape suivante (",this.element[i].instruction.etape.ID,")")
                                }
                            }
                        }
                        const message = res.result.length+' procédure(s) modifiée(s).';
                        let snackBarRef = this.snackbar.open(message,'', {
                            duration: 1500
                        });
                        if(res.result.length>0){
                            this.getDataPageInsctrution(this.currentPageInstruction,true);
                        }

                    } else {
                        console.log("Boite dialogue fermée avec erreur")
                    }
                })
            }
        }

        if (res.cancel) {
            for(let i=0;i<this.element.length;i++){
                for(let k=0;k<res.tabID.length;k++){
                    if(this.element[i].instruction.ID == res.tabID[k]){
                        instruction.push(this.element[i].instruction.ID)
                    }
                }
            }
            this.instructionService.annulerGroup(instruction).subscribe((res: JSONRpcResponse) => {
                if(res){
                    for(let i=0;i<res.result.length;i++){
                        if(res.result[i].ID == this.element[i].instruction.ID){
                            this.element[i].instruction = res.result[i];
                        } else {
                            for(let k=0;k<this.element.length;k++){
                                if(res.result[i].ID == this.element[k].instruction.ID){
                                    this.element[k].instruction = res.result[i];
                                }
                            }
                        }
                    }
                    const message = res.result.length+' procédure(s) modifiée(s).';
                    let snackBarRef = this.snackbar.open(message,'', {
                        duration: 1500
                    });
                    if(res.result.length>0){
                        this.getDataPageInsctrution(this.currentPageInstruction,true);
                    }
                }
            })
        }
    }

    editSynthese() {
        var dossierIds = [];
		this.element.forEach(elem => {
			dossierIds.push(elem["dossier"]["dossierID"]);
		} );
		let _options:any={
			filters:[],
			sorts:[]
		}
		this.listeService.exports("SYNTHESE",dossierIds,_options).subscribe((res: JSONRpcResponse) => {

			console.log("editData SYNTHESE",res);

			if (res.result) {
				for(let i=0;i<res.result.length;i++){
					let r=res.result[i];
					console.log("editData SYNTHESE line",r);
					if (r.datas && r.datas.url!=undefined)
						window.open(r.datas.url);
				}
			}
			this.changeDetectorRef.detectChanges();
		});
  	}

      editCourrier() {
		
		//
		
		const dialogRef=this.dialogService.open(ChoiceCourrierComponent, {
            data: {
                typeDemande: this.demande,
                /*state: this.currentState,*/
                panierLines: this.element,
				droitsObjets: this.user.droitsObjets
            },
            width: "30vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        }, (result: any) => {
            if (result) { }
        })

        const sub = dialogRef.componentInstance.onFormClosed.subscribe((result: any) => {
            console.log('Result courriers download',result);
            if(result && result.zipFile && result.zipFile.url){
				
					const dial=this.dialogService.open(LoadDialogComponent, {
												               data: {
												                   url: result.zipFile.url
												               },
															   height: "95vh",
															   width: "80%",
															   minimizable: true,
															   maximizable: true,
															   draggable: true,
												           }, (res: any) => {
												               
												           })
				
                //window.open(result.zipFile.url,' _blank');
            }
		})
	}

	addVisite(){
	        let dossiers = [];
			this.element.forEach(elem => {
						dossiers.push(elem["dossier"]);
			} );
			
			
	        console.log("addVisite dossiers",dossiers);
	        const dialogRef = this.dialogService.open(VisiteActionsDialog, {
	            data: {
	                action: "create",
	                dataType: "rdv",
	                lots: dossiers,
	                title: "Création d'un rendez-vous",
	                create: true,
	            },
	            height: "95vh",
	            width: "80vw",
	            draggable: true,
	            resizable: true,
	            minimizable: true,
	            maximizable: true,
	        })
	    }
		
		exporter(format:string) {
					 
						let _options:any = 			{
					            pageSize:this.PaginationInstruction,
					            sorts: [this.sortInstruction],
					            filters: {
					                zone: {value:this.parameters.zoneInput},
					                tiers: {value:this.parameters.tiersInput},
					                metier : {value:this.parameters.metierInput},
					                enCours : {value:this.parameters.enCoursInput},
					                procedure : {value:this.parameters.procedureInput},
					                action : {value:this.parameters.actionInput},
					                statut : {value:this.parameters.statutInput},
					                commune : {value:this.parameters.communeInput},
									alltiers: {value:this.parameters.allTiersInput},
									grouptiers: {value:this.parameters.allGroupTiersInput},
									groupListtiers: {value:this.parameters.allGroupTiersListInput},
					            },
								format: format
					        };
						
						
						   this.loadingInstruction = true;
						   console.log('before export',_options);
						   this.listeService.export('INSTRUCTION', _options)
						     .subscribe(  (myexport) => {
						       this.loadingInstruction = false;
						       console.log('export',myexport);
						       
						       if (myexport.result!=undefined
						        && myexport.result.datas!=undefined
						        && myexport.result.datas.file!=undefined) {
									const dial=this.dialogService.open(LoadDialogComponent, {
											               data: {
											                   url: myexport.result.datas.file
											               },
														   height: "95vh",
														   width: "80%",
														   minimizable: true,
														   maximizable: true,
														   draggable: true,
											           }, (res: any) => {
											               
											           })
									
						            //window.open(myexport.result.datas.file, '_blank');
									
								}	
						       this.changeDetectorRef.detectChanges();
						   });
			
		}	  
		 
}
